import { TableFooter as MuiTableFooter, tableFooterClasses as muiTableFooterClasses, } from '@mui/material';
export const TableFooter = MuiTableFooter;
export const tableFooterClasses = muiTableFooterClasses;
